import React, { useEffect } from 'react'
import ExperienceList from '../components/ExperienceList';
import GmImg from '../assets/img/experiences/gm.jpg'
import BwaImg from '../assets/img/experiences/bwa.svg'
import JciImg from '../assets/img/experiences/jci.png'
import ItpiImg from '../assets/img/experiences/itpi.jpg'
import DImg from '../assets/img/experiences/d.webp'

const Experiences = () => {

    useEffect(() => {
        document.title = 'Arya Rizky Tri Putra - Experiences'
    }, []);

    return <section className='text-light container mx-auto pb-32  mt-24 px-5'>
        <h3 className='font-black md:text-3xl text-2xl mb-10 text-center'>My Amazing Experiences🚶‍♂️</h3>

        <ExperienceList at="May 2021" end="Present" img={GmImg} title="Fullstack Developer" desc="Create a backend service with Laravel and use Mysql as a database and Create frondend with Nuxt.js." company="PT. Menggapai Indonesia Cerdas" type="Part Time" />

        <ExperienceList at="September 2021" end="November 2021" img={JciImg} title="INTEL Prakarsa Muda 2021" desc="Take training to create artificial intelligence and simple data science with python." company="JCI East Java" type="Intern" />

        <ExperienceList at="May 2021" end="September 2021" img={ItpiImg} title="Junior Programmer" desc="Create a website frondend with angular.js, create a backend with slim, and manage databases with PostgreSQL" company="PT. ITPI Technology" type="Contract" />

        <ExperienceList at="February 2021" end="February 2021" img={BwaImg} title="BWA Laravue" desc="Create a backend service with Laravel and use Mysql as a database and Create frondend with Vue.js." company="Build With Angga" type="Online Course" link="https://drive.google.com/file/d/1-0B0sB-dGrIJfAU86tEh7CDBgZvHTuvW/view?usp=sharing" />

        <ExperienceList at="August 2020" end="August 2020" img={DImg} title="PWA Course" desc="Create a simple Progressive Web Apps with Vanilla.js" company="Dicoding" type="Online Course" link="https://drive.google.com/file/d/1GEMuMkLKuEA47eAiVGyOhBSz9FqxmG-u/view?usp=sharing" />

    </section>
}

export default Experiences
